import React from 'react';
import { Link } from 'react-router-dom';
export function Footer() {
  return <footer className="bg-[#0A1D37] text-white" data-id="element-9">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-10">
        <div className="md:flex md:justify-between" data-id="element-11">
          <div className="mb-6 md:mb-0" data-id="element-12">
            <Link to="/" className="text-xl font-bold" data-id="element-13">
              Forgepoint Management LLC
            </Link>
            <p className="mt-2 text-sm text-gray-300" data-id="element-14">
              Forgepoint Management LLC respects your privacy. We do not sell
              your information. By submitting your details, you consent to our
              use of your data as outlined in our
              <Link to="/privacy-policy" className="text-[#10B981] hover:text-[#0DD393]" data-id="element-15">
                {' '}
                privacy policy
              </Link>
              .
            </p>
          </div>
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 md:grid-cols-3 mt-8 md:mt-0" data-id="element-16">
            <div data-id="element-17">
              <h3 className="text-sm font-semibold uppercase tracking-wider" data-id="element-18">
                Company
              </h3>
              <ul className="mt-4 space-y-2" data-id="element-19">
                <li data-id="element-20">
                  <Link to="/" className="text-gray-300 hover:text-[#10B981]" data-id="element-21">
                    About
                  </Link>
                </li>
                <li data-id="element-22">
                  <Link to="/" className="text-gray-300 hover:text-[#10B981]" data-id="element-23">
                    Properties
                  </Link>
                </li>
                <li data-id="element-24">
                  <Link to="/" className="text-gray-300 hover:text-[#10B981]" data-id="element-25">
                    Contact
                  </Link>
                </li>
              </ul>
            </div>
            <div data-id="element-26">
              <h3 className="text-sm font-semibold uppercase tracking-wider" data-id="element-27">
                Legal
              </h3>
              <ul className="mt-4 space-y-2" data-id="element-28">
                <li data-id="element-29">
                  <Link to="/privacy-policy" className="text-gray-300 hover:text-[#10B981]" data-id="element-30">
                    Privacy Policy
                  </Link>
                </li>
                <li data-id="element-31">
                  <Link to="/sms-policy" className="text-gray-300 hover:text-[#10B981]" data-id="element-32">
                    SMS Policy
                  </Link>
                </li>
                <li data-id="element-33">
                  <Link to="/" className="text-gray-300 hover:text-[#10B981]" data-id="element-34">
                    Terms of Service
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div className="mt-8 border-t border-gray-700 pt-8" data-id="element-35">
          <p className="text-sm text-gray-300" data-id="element-36">
            © {new Date().getFullYear()} Forgepoint Management LLC. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
}